import { CCard, CCardText } from "@coreui/react";
import React from "react";

const LogList = ({ logs = [], textColor }) => {
  return (
    <>
      {logs?.length ? (
        <CCard className="m-2 p-2">
          {logs.map((log, idx) => {
            return (
              <CCardText key={idx} className={`${textColor}`}>
                {log}
              </CCardText>
            );
          })}
        </CCard>
      ) : null}
    </>
  );
};

export default LogList;
